import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function PendingPage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  function handleLogout() {
    logout();
    navigate('/login');
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6" style={{
      backgroundColor: '#0d1b2e',
      backgroundImage: "url('/topo-bg.svg'), radial-gradient(ellipse at center, #142236 0%, #0d1b2e 70%)",
      backgroundRepeat: 'no-repeat, no-repeat',
      backgroundSize: 'cover, cover',
      backgroundAttachment: 'fixed, fixed',
    }}>
      <div className="mb-8 text-center">
        <img src="/img/blvd-logo.png" alt="BLVD" className="h-12 w-auto mx-auto" />
        <p className="text-gray-400 text-xs tracking-widest uppercase mt-1">Geospatial Portal</p>
      </div>

      <div className="w-full max-w-md border rounded-xl p-8 text-center" style={{ backgroundColor: '#0d1b2e', borderColor: '#1e3a5f' }}>
        <div className="text-5xl mb-4">⏳</div>
        <h2 className="text-white font-bold text-lg mb-2">Access Pending</h2>
        <p className="text-gray-400 text-sm leading-relaxed">
          Welcome{user?.name ? `, ${user.name.split(' ')[0]}` : ''}. Your account is set up, but an administrator
          needs to assign your permissions before you can get in.
        </p>
        <p className="text-gray-500 text-xs mt-3">You'll have access as soon as they do. Check back shortly.</p>

        <button
          onClick={handleLogout}
          className="mt-6 text-xs text-gray-500 hover:text-gold-400 uppercase tracking-widest transition"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
